import {
  SEND_ATTRACTIONS_DATA,
  SEND_ATTRACTIONS_DATA_SUCCESS,
  SEND_ATTRACTIONS_DATA_FAILURE,
  DELETE_ATTRACTIONS_DATA_SUCCESS,
  SEND_TICKETS_DATA,
  SEND_TICKETS_DATA_SUCCESS,
  SEND_TICKETS_DATA_FAILURE,
  DELETE_TICKET,
  DELETE_TICKETS_DATA_SUCCESS,
  SEND_TICKETS_CATEGORIES_DATA,
  SEND_TICKETS_CATEGORIES_DATA_SUCCESS,
  SEND_TICKETS_CATEGORIES_DATA_FAILURE,
  DELETE_TICKETS_CATEGORIES_DATA_SUCCESS,
} from '../../constants/ActionTypes';

export default function publishingAttractionsReducer(state, action) {
  let nextAttractions = [];

  switch (action.type) {
    case SEND_ATTRACTIONS_DATA:
    case SEND_TICKETS_DATA:
    case SEND_TICKETS_CATEGORIES_DATA:
      return {
        ...state,
        isSaving: true,
      };

    case SEND_ATTRACTIONS_DATA_SUCCESS:
      return {
        ...state,
        attractions: action.attractions || state.attractions,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case DELETE_ATTRACTIONS_DATA_SUCCESS:
      return {
        ...state,
        attractions: state.attractions.filter((x) => x.id !== action.id),
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_ATTRACTIONS_DATA_FAILURE:
    case SEND_TICKETS_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case SEND_TICKETS_DATA_SUCCESS:
      nextAttractions = state.attractions.map((a) => {
        if (a.id === action.attractionId) {
          if (a.tickets.some((t) => t.id === action.ticketId)) {
            return {
              ...a,
              tickets: a.tickets.map((t) =>
                t.id === action.ticketId ? action.data : t
              ),
            };
          }
          return { ...a, tickets: [...a.tickets, action.data] };
        }
        return a;
      });

      return {
        ...state,
        attractions: nextAttractions,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case DELETE_TICKETS_DATA_SUCCESS:
      nextAttractions = state.attractions.map((a) =>
        a.tickets.some((t) => t.id === action.ticketId)
          ? {
              ...a,
              tickets: a.tickets.filter((t) => t.id !== action.ticketId),
            }
          : a
      );

      return {
        ...state,
        attractions: nextAttractions,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_TICKETS_CATEGORIES_DATA_SUCCESS:
      nextAttractions = state.attractions.map((a) =>
        a.tickets.some((t) => t.id === action.ticketId)
          ? {
              ...a,
              tickets: a.tickets.map((tc) =>
                tc.id === action.ticketId
                  ? {
                      ...tc,
                      pricingCategories: tc.pricingCategories.some(
                        (pc) => pc.id === action.data.id
                      )
                        ? tc.pricingCategories.map((pct) =>
                            pct.id === action.data.id ? action.data : pct
                          )
                        : [...tc.pricingCategories, action.data],
                    }
                  : tc
              ),
            }
          : a
      );

      return {
        ...state,
        attractions: nextAttractions,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case DELETE_TICKET:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
        isNotSaved: false,
      };

    case DELETE_TICKETS_CATEGORIES_DATA_SUCCESS:
      nextAttractions = state.attractions.map((a) =>
        a.tickets.some((t) => t.id === action.idTicket)
          ? {
              ...a,
              tickets: a.tickets.map((t) =>
                t.id === action.idTicket
                  ? {
                      ...t,
                      pricingCategories: t.pricingCategories.some(
                        (pc) => pc.id === action.idCategory
                      )
                        ? t.pricingCategories.filter(
                            (pc) => pc.id !== action.idCategory
                          )
                        : t.pricingCategories,
                    }
                  : t
              ),
            }
          : a
      );

      return {
        ...state,
        attractions: nextAttractions,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_TICKETS_CATEGORIES_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    default:
      return state;
  }
}
